import { zIndex } from '../../../config/styles';

export const classes = {
  container: 'tooltip-container',
  title: 'tooltip-title',
  text: 'tooltip-text',
  button: 'tooltip-button',
};

export const TooltipStyles = (
  <style jsx>{`
    .tooltip-container {
      position: absolute;
      background: white;
      padding: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      width: 280px;
      z-index: ${zIndex.Tooltip.container};
      pointer-events: auto;
      display: flex;
      flex-direction: column;
    }
    .tooltip-container.top {
      left: 50%;
      bottom: 100%;
      transform: translateX(-50%);
      margin-bottom: 15px;
    }
    .tooltip-container.left {
      left: -310px;
      top: -20%;
    }
    .tooltip-container.right {
      left: 100%;
      top: -20%;
    }
    .tooltip-title {
      color: #333;
      margin-bottom: 8px;
      font-family: Lato, sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
    .tooltip-text {
      margin-bottom: 16px;
      font-family: Lato, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: #505050;
    }
    .tooltip-button {
      background: #0072ce;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      pointer-events: auto;
      width: 112px;
      align-self: flex-end;
    }
  `}</style>
);
